import { TFunction } from 'next-i18next'
import { RegisterOptions, Validate } from 'react-hook-form'
import { isUndefinedOrEmpty } from '@afterpay/utils/string'
import { addressHasNoPO, AllCountryCode, InputAddressData } from '@afterpaytouch/core'
import { isValidObject } from '@afterpaytouch/form/lib/utils/object'
import { validateProfileField } from '../../utils/profile-validation'

export const namePattern =
  (t: TFunction) =>
  (name: string): RegisterOptions => {
    // This pattern validates for characters, spaces, digits, hyphens, apostrophes and ampersands

    // For example
    //     aC12 3'456
    //     Hg&6-543''21
    //     1334DG -F343

    // Not allowed:
    //     Ac24*2343
    //     ∴a892ljaa
    //     *&23LKJ@@
    const validationRegex = /^$|^[a-zA-Z\u00C0-\u017F][a-zA-Z\u00C0-\u017F- ']*$/

    return {
      pattern: {
        value: validationRegex,
        message: t('addNewAddress:error:invalid', { context: name }),
      },
    }
  }

export const requiredValidation =
  (t: TFunction) =>
  (name: string): RegisterOptions => ({
    required: t('addNewAddress:error:invalid', { context: name }),
  })

export const validAddressOption = (address: InputAddressData, country: AllCountryCode): boolean => {
  if (!isValidObject(address)) {
    return false
  }

  const addressKeys = Object.keys(address)

  for (const key of addressKeys) {
    const isValidValue = validateProfileField(country, key, address[key])
    if (!isValidValue) {
      return false
    }
  }
  return true
}

export const requiredAddress = ({ name, country, t }): Record<string, Validate<InputAddressData, Record<string, unknown>>> => {
  return {
    requiredAddressFields: (v, _) => {
      const hasRequiredAddressFields = validAddressOption(v, country)
      return hasRequiredAddressFields || t('addNewAddress:error:invalid', { context: name })
    },
  }
}

export const validatePoBox = (message: string): Record<string, Validate<InputAddressData, Record<string, unknown>>> => {
  return {
    noPoBox: (address, _) => {
      return addressHasNoPO(address) || message
    },
  }
}

export const requiredPhone = (name, mobile, t): RegisterOptions => {
  return {
    validate: {
      validPhone: (v) => {
        const isValidPhone = !isUndefinedOrEmpty(mobile)
        return isValidPhone || t('addNewAddress:error:invalid', { context: name })
      },
    },
  }
}
